/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Shipping_N_Delivery__Answer_0Inputs */

const en_help_center__shipping_n_delivery__answer_0 = /** @type {(inputs: Help_Center__Shipping_N_Delivery__Answer_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Shipping only available within the Netherlands and Belgium.) We currently do not ship to other countries. All products are shipped from authorized dealers within these regions.`)
};

/**
* | output |
* | --- |
* | "(Shipping only available within the Netherlands and Belgium.) We currently do not ship to other countries. All products are shipped from authorized dealers w..." |
*
* @param {Help_Center__Shipping_N_Delivery__Answer_0Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__shipping_n_delivery__answer_0 = /** @type {((inputs?: Help_Center__Shipping_N_Delivery__Answer_0Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Shipping_N_Delivery__Answer_0Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__shipping_n_delivery__answer_0(inputs)
});